'use strict';

var Card = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card',
		is_autorun: true,
		is_preloaded: true,
		first_autorun_duration: 5000,
		autorun_duration: 5500,
		transition_duration: 200
	},

	initialize: function initialize(_element, options) {
		this.setOptions(options);

		this._element = _element || document.getElement('.' + this.options.cls);

		if (this._element) {
			this.build();
			this.adaFix();
		}
	},

	adaFix: function adaFix() {
		this._element.setAttribute('role', 'region');
		this._element.setAttribute('aria-label', 'carousel');
	},

	build: function build() {
		var _this2 = this;

		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.is_first = true;
		this.pagination = null;

		this._btnprevious = _this.getElement(fcls + '_btnprevious') || new Element('div');
		this._btnnext = _this.getElement(fcls + '_btnnext') || new Element('div');
		this._stage = _this.getElement(fcls + '_stage');
		this._pagination = _this.getElement(fcls + '_pagination') || new Element('div', { 'class': opts.cls + '_pagination' }).inject(this._stage, 'after');
		this._items = _this.getElements(fcls + '_item');

		this.stage = new Card.Stage(this._stage, this._items, this);

		if (this._items.length == 1) {
			this.set_image(0);

			this._btnprevious.dispose();
			this._btnnext.dispose();
		} else {
			this.pagination = new Card.Pagination(this._pagination, this);

			this._btnprevious.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_previous_image();
			}.bind(this));

			this._btnnext.addEvent('click', function () {
				this.is_clicked = true;
				this.clear_periodical();
				this.set_next_image();
			}.bind(this));

			this.set_image(0);

			this.periodical = null;

			if (opts.is_autorun) {
				// will have to inject a play / pause button if it is auto play
				var playOrPause = new Element('button', {
					html: 'Pause',
					'class': 'card-play-pause no-style'
				});

				// should be place after w_card_btnprevious
				var previousBtn = this._element.querySelector('.w_card_btnprevious');
				if (!previousBtn) return;
				playOrPause.inject(previousBtn, 'after');
				playOrPause.addEventListener('click', function () {
					if (_this2.periodical) _this2.clear_periodical();else _this2.autoPlay();
				});
				this.playOrPause = playOrPause;
				this.autoPlay();
			}
		}
	},

	autoPlay: function autoPlay() {
		var opts = this.options;
		this.set_direction('next');
		this.playOrPause.innerHTML = 'Pause';
		(function () {
			this.set_next_image();

			this.clear_periodical();
			this.periodical = this.set_next_image.periodical(this.options.autorun_duration, this);
		}).bind(this).delay(opts.first_autorun_duration);
	},

	clear_periodical: function clear_periodical() {
		if (this.options.is_autorun && this.periodical) {
			clearInterval(this.periodical);
			this.periodical = null;
			this.playOrPause.innerHTML = 'Play';
		}

		return this;
	},

	get_direction: function get_direction() {
		return this.direction;
	},

	set_direction: function set_direction(direction) {
		this.direction = direction;
		return this;
	},

	set_image: function set_image(index) {
		if (!this.is_animating) {
			this.stage.set_image_by_index(index);

			if (this.pagination) {
				this.pagination.set_current_page_index(index);
			}
		}
	},

	set_next_image: function set_next_image() {
		this.set_direction('next');
		this.set_image(this.pagination.retrieve_next());
	},

	set_previous_image: function set_previous_image() {
		this.set_direction('previous');
		this.set_image(this.pagination.retrieve_previous());
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Pagination = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_pagination'
	},

	initialize: function initialize(_element, card, options) {
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.card = card;
		this.build();
	},

	build: function build() {
		var _this = this._element;

		this.items = [];
		this.current_page_index = 0;

		this.card._items.length.times(function (i) {
			var item = new Element('a', {
				'href': '#',
				'html': '',
				events: {
					click: function (e) {
						if (e && e.stop) e.stop();

						if (i == this.get_current_page_index()) return;

						var direction = this.get_current_page_index() < i ? 'next' : 'previous';

						this.card.is_clicked = true;
						this.card.clear_periodical().set_direction(direction).set_image(i);
					}.bind(this)
				}
			}).inject(_this);

			this.items.push(item);
		}.bind(this));
	},

	get_current_page_index: function get_current_page_index() {
		return this.current_page_index;
	},

	retrieve_next: function retrieve_next() {
		var count = this.items.length;

		if (this.current_page_index == count - 1) {
			return 0;
		}

		return this.current_page_index + 1;
	},

	retrieve_previous: function retrieve_previous() {
		var count = this.items.length;

		if (this.current_page_index == 0) {
			return count - 1;
		}

		return this.current_page_index - 1;
	},

	set_current_page_index: function set_current_page_index(index) {
		this.items[this.current_page_index].removeClass('selected');
		this.current_page_index = index;
		this.items[index].addClass('selected');
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Stage = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_stage'
	},

	initialize: function initialize(_element, _items, card, options) {
		if (!_element) return;

		this.setOptions(options);

		this._element = _element;
		this._items = _items;
		this.card = card;
		this.build();
	},

	build: function build() {
		var opts = this.options,
		    fcls = '.' + opts.cls,
		    _this = document.id(this);

		this.active_item = null;
		this.items = [];
		this.times_accessed = 0;

		this._canvas = _this.getElement(fcls + '_canvas');

		this._items.each(function (_item, i) {
			var item_options = {};

			if (i == 0) {
				item_options = {
					preloads: false
				};
			}

			this.items.push(new Card.Item(_item, this, this.card, item_options));
		}.bind(this));

		if (this.card.options.is_preloaded) {
			this.preload();
		}
	},

	preload: function preload() {
		var images = [];

		this.items.each(function (itm) {
			images.push(itm.get_src());
		}.bind(this));

		Asset.images(images, {
			onProgress: function (c, i) {
				this.items[i].is_loaded = true;
				this.items[i].set_image();
			}.bind(this),

			onComplete: function () {
				this.fireEvent('on_preload');
			}.bind(this)
		});
	},

	get_container: function get_container() {
		return this._canvas;
	},

	set_image: function set_image(item) {
		if (this.active_item) {
			this.active_item.close();
		}

		this.active_item = item;
		item.open();
		item.set_image();
		this.times_accessed++;
	},

	set_image_by_index: function set_image_by_index(index) {
		this.set_image(this.items[index]);
	},

	toElement: function toElement() {
		return this._element;
	}
});

Card.Item = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_card_item',
		preloads: true
	},

	initialize: function initialize(_element, stage, card, options) {
		//console.log(_element); return;
		if (!_element) return;

		this.setOptions(options);
		this._element = _element;
		this.stage = stage;
		this.card = card;
		this.build();
	},

	build: function build() {

		var _this = document.id(this);

		this.has_image = false;

		var _img = _this.getElement('img') || _this;

		this.src = _img.getAttribute('data-image');
		this.url = _this.getAttribute('data-url') || false;
		this.targeted = _this.getAttribute('data-target') || false;

		if (this.url) {
			this.enable_card_click();
		}

		this.is_loaded = false;

		this.width = _this.getSize().x;

		var dur = this.card.options.transition_duration || 0;
		this._element.set('tween', { link: 'cancel', duration: dur });
	},

	enable_card_click: function enable_card_click() {
		this._element.setStyle('cursor', 'pointer');
		this._element.addEvent('click', function () {
			this.go_to_url();
		}.bind(this));
	},

	go_to_url: function go_to_url() {
		if (this.targeted) {
			window.open(this.url, this.targeted);
			return;
		}

		location.href = this.url;
	},

	close: function close() {
		var _this = this._element;

		_this.removeClass('active');

		var __hide = function __hide() {
			_this.setStyle('left', '150%');
			_this.get('tween').removeEvent('complete', __hide);
		};

		_this.set('tween', {
			onComplete: __hide
		});

		_this.tween('opacity', 0);

		this.fireEvent('close');
	},

	preload: function preload() {
		if (this.options.preloads) {
			Asset.image(this.src);
		}
	},

	load_image: function load_image() {
		(function () {
			Asset.image(this.src, {
				onLoad: function () {
					this.is_loaded = true;
					this.set_image();
				}.bind(this)
			});
		}).delay(300, this);
	},

	open: function open() {
		var _this = this._element;

		// CITY-5616: a slide the page already shows (server-rendered with .active
		// ._preshown, e.g. the zone hero) — no fade-in from 0.1
		if (_this.hasClass('_preshown')) {
			_this.removeClass('_preshown');
			_this.setStyles({ 'opacity': 1, 'left': 0 });
			this.fireEvent('open');
			return;
		}

		_this.addClass('active');

		_this.setStyles({
			'opacity': 0.1,
			'left': 0
		});

		_this.tween('opacity', 1);

		this.fireEvent('open');
	},

	get_src: function get_src() {
		return this.src;
	},

	set_image: function set_image() {
		if (!this.is_loaded && !this.card.options.is_preloaded) {
			this.load_image();
		} else {
			if (!this.has_image) {
				this.has_image = true;
				var sanitized = this.src.trim();
				// document.id(this).setStyle('background-image', 'url('+sanitized+')');
				var _this = document.id(this);
				var _img = _this.getElement('img') || _this;

				_img.setProperty('src', sanitized);
			}
		}
	},

	toElement: function toElement() {
		return this._element;
	}
});
'use strict';

var ScrollToElement = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'scroll_to',
		offset_y: 0
	},

	initialize: function initialize(_elements, options) {
		this.setOptions(options);
		this._elements = _elements || document.getElements('.' + this.options.cls);

		if (this._elements) {
			this.build();
		}
	},

	build: function build() {
		this.setScrollTo();
	},

	setScrollTo: function setScrollTo() {
		var self = this;

		var myFx = new Fx.Scroll(window, {
			offset: {
				x: 0,
				y: self.options.offset_y,
				duration: 1000
			},
			onStart: function onStart() {
				$(window).fireEvent('jumpStart');
			},
			onComplete: function onComplete() {
				$(window).fireEvent('jumpStop');
			}

		});

		this._elements.each(function (link) {
			link.addEvent('click', function (e) {
				if (e && e.stop) e.stop();

				if (this.hasClass('_top')) {
					myFx.toTop();
					return;
				}

				var name = (this.get('data-href') || this.get('href') || this.href).split('#')[1];
				var elem = $$('a[name=' + name + ']');
				myFx.toElement(elem[0], 'y');
			});
		});
	}
});
'use strict';

Page.Ndd = new Class({
	Extends: Page,
	build: function build() {
		this.parent();

		var _card = document.querySelector('.w_card');
		new Card(_card);

		new ScrollToElement();
	}
});
//# sourceMappingURL=ndd.js.map
